import styles from "./styles.module.scss";
import { useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { themeGrid } from "../../../../themeGrid";
import { localeText } from "../../../../localeTextFromGrid";
import { ColDef, IGetRowsParams } from "ag-grid-community";
import TextField from "@mui/material/TextField/TextField";
import InputAdornment from "@mui/material/InputAdornment/InputAdornment";
import { IProjectBudgetMonthliesPage } from "../../../../@types/project/project-budget.type";

const CustomInputField = props => {
  return (
    <>             
      <TextField
        value={props.value}
        InputLabelProps={{
          shrink: true,
        }}
        type="number"
        InputProps={{
          endAdornment: (
              <InputAdornment position="end">
                  h
              </InputAdornment>
          ),
        }}
        onChange={(obj) => props.setValue(obj.currentTarget.valueAsNumber)}
        className={styles.customInputField}
      />
    </>
  );
};

const columnsDefault: ColDef[] = [
  { field: "monthAndYear", headerName: "Período", flex: 1, minWidth: 150, editable: false },
  { field: "month", headerName: "Mês", flex: 1, minWidth: 150, editable: false, hide: true },
  { field: "year", headerName: "Ano", flex: 1, minWidth: 70, editable: false, hide: true },
  { field: "workingHours", 
    headerName: "Carga Horária", 
    flex: 1, 
    minWidth: 70, 
    editable: false,
    cellRenderer: CustomInputField
  },
];

interface PerfilTimeGridProps {
  gridArray: IProjectBudgetMonthliesPage[],
}

export const PerfilTimeGrid: React.FC<PerfilTimeGridProps> = ({gridArray}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const gridRef = useRef<AgGridReact<any>>(null);
  const [columns, setColumns] = useState(columnsDefault);

  const getDataSource = () => ({
    getRows: async (params: IGetRowsParams) => {
      try {
        params.successCallback(
         gridArray,
         gridArray.length
        );
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
        params.failCallback(); // Notifica falha no carregamento
      }
    },
  });

  return (
    <div className={styles.dataGridContainer}>
      <AgGridReact
          ref={gridRef}
          theme={themeGrid}
          localeText={localeText}
          loading={loading}
          columnDefs={columns}
          overlayNoRowsTemplate="<span style='color: gray;'>Sem registros encontrados</span>"
          defaultColDef={{
            sortable: false,
            editable: true,
            filter: false,
            floatingFilter: false,
          }}
          suppressCellFocus={true}
          rowStyle={{ cursor: "pointer" }}
          cacheBlockSize={50}
          rowModelType="infinite"
          datasource={getDataSource()}
          animateRows={true}
          // onRowDataUpdated={teste}
        />
    </div>   
  );
};
